module.exports = __webpack_public_path__ + "static/media/eco-ecology-nature-18-svgrepo-com.e1293082.svg";